import React from "react";
import { ProductsContext } from "../../context/ProductsContext";
import products from "../../consts/products";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";

const Question1 = ({ setAnswer1, addStep }) => {
  const { p3, p1_p2Visible } = React.useContext(ProductsContext);
  const [product3, setProduct3] = p3;
  const [product1_2Visible, setProduct1_2Visible] = p1_p2Visible;
  const answerHandler = (option) => {
    setAnswer1(option);
    product3Handler(option);
    product1_2VisibleHandler(option);
    addStep();
  };
  const product3Handler = (answer1) => {
    let result = "";
    if (answer1 === "option1" || answer1 === "option2") {
      result = "I";
    } else if (answer1 === "option3" || answer1 === "option4") {
      result = "H";
    }
    const product = products.find((p) => p.id === result);
    setProduct3(product);
  };
  const product1_2VisibleHandler = (answer1) => {
    if (answer1 === "option2" || answer1 === "option4") {
      setProduct1_2Visible(false);
    }
    else{
      setProduct1_2Visible(true);
    }
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
      <source src={bg_video} type="video/mp4"></source>
      </video>

      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            1 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--1 c-box2 p-question__content--1n">
      <h1 class="c-question__title p-question__title">MENU SELECT</h1>
        <section
          onClick={() => answerHandler("option1")}
          className="c-question__option p-question__option p-question__option--1"
        >
          <a>
            <div class="lt">
              <h2>うねり、クセの改善まで対応する<br/>プレミアムメニュー</h2>
            </div>
            <div class="rt">
              <ul>
                <li><span>外部<br/>補修</span></li>
                <li><span>内部<br/>補修</span></li>
                <li><span>うねり<br/>ケア</span></li>
              </ul>
            </div>
          </a>
        </section>
        <section
          onClick={() => answerHandler("option3")}
          className="c-question__option p-question__option p-question__option--1"
        >
          <a>
            <div class="lt">
              <h2>理想の質感へと導く<br/>スタンダードメニュー</h2>
            </div>
            <div class="rt">
              <ul>
                <li><span>外部<br/>補修</span></li>
                <li><span>内部<br/>補修</span></li>
              </ul>
            </div>
          </a>
        </section>
        <section
          onClick={() => answerHandler("option4")}
          className="c-question__option p-question__option p-question__option--1"
        >
          <a>
            <div class="lt">
              <h2>キューティクル補修を中心とした<br/>クイックメニュー</h2>
            </div>
            <div class="rt">
              <ul>
                <li><span>外部<br/>補修</span></li>
              </ul>
            </div>
          </a>
        </section>
      </section>
    </section>
  );
};

export default Question1;
